import { useQuery } from 'react-query'
import { gridClient } from '@/utils/apiUtil'

export const getSignUpFormRequest = async () => {
  const { data } = await gridClient.get('/registration/form/dynamic')
  return data
}

export const sendResetPasswordEmailRequest = async ({ email }) => {
  const { data } = await gridClient.post(`/auth/request/reset/password/${email}`)
  return data
}

export const sendUnlockAccountEmailRequest = async ({ email }) => {
  const { data } = await gridClient.post(`/auth/request/unlock/${email}`)
  return data
}

export function getSignUpFormHook() {
  return useQuery(['get-sign-up-form'], getSignUpFormRequest, { refetchOnWindowFocus: false })
}

export const dynamicFormRequest = async ({ method, url, payload }) => {
  const { data } = await gridClient[method.toLowerCase()](url, payload)
  return data
}

export const dynamicInviteFormRequest = async ({ method, url, payload }) => {
  const { data } = await gridClient[method.toLowerCase()](url, payload)
  return data
}
